import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sidebar"
}
const _hoisted_2 = {
  key: 2,
  class: "navigation-menu"
}
const _hoisted_3 = ["onClick"]

import { IonButton, IonIcon, IonMenuToggle, IonMenu, menuController } from '@ionic/vue';
import { computed, onMounted, ref } from 'vue';
import { appNav } from '@/const/navigation';
import {useBreakpoint } from '@/hooks/useBreakpoint'
import NavigationMenu from '@/modules/General/components/NavigationMenu.vue'
import router from '@/router';
import { MenuItem } from '@/interfaces/MenuItem';
import { MenuButton } from '@/interfaces/MenuButton';
import { isMobile } from '@/helpers/isMobile';
import { isAbleToDo } from '@/helpers/isAbleToDo';
import { ProfileSettingsEnum } from '@/gql/graphql';
import { NavigationItem } from '@/interfaces/NavigationItem';
import { useUserStore } from '../store/userStore';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarComponent',
  setup(__props) {

const user = computed(() => useUserStore()?.user);
const route = useRoute();

const checkRoute = (item: NavigationItem) => isAbleToDo(user.value, ProfileSettingsEnum.PostWork) ? item : '';

const { isDesktop } = useBreakpoint();

const isMenuOpen = ref<boolean>(false);

const toggleMenu = () => {
  menuController.toggle('app-menu')
  isMenuOpen.value = !isMenuOpen.value
}

const navigate = (item: MenuItem | MenuButton | NavigationItem) => {
  if(item?.route) {
    if(!item?.disabled) {
      menuController.close('app-menu').then(() =>{
        router.push({name: item?.route})
      })
    }
  } else {
    menuController.close('app-menu').then(() =>{
      router.push({
        name: item?.name,
        params: { id : item?.id },
        query: item?.query
      });
    })
  }
}

if(isMobile.value && window.history.state.back === '/login' && (user.value?.team?.is_active_subscriber || user.value?.is_impersonated)) {
  setTimeout(async () => {
    if(await menuController.isEnabled('app-menu')) {
      toggleMenu()
    }
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(NavigationMenu, {
            onOnNavigate: _cache[0] || (_cache[0] = ($event: any) => (navigate($event)))
          })
        ]))
      : _createCommentVNode("", true),
    (!_unref(isDesktop))
      ? (_openBlock(), _createBlock(_unref(IonMenu), {
          key: 1,
          class: "side-menu",
          "content-id": "main-content",
          "menu-id": "app-menu"
        }, {
          default: _withCtx(() => [
            _createVNode(NavigationMenu, {
              onOnNavigate: _cache[1] || (_cache[1] = ($event: any) => (navigate($event)))
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(IonMenuToggle), { class: "holder-btn" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButton), {
                onClick: toggleMenu,
                fill: "clear",
                class: _normalizeClass(["navigation-menu__navigation-btn", {'active': isMenuOpen.value }])
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    src: "assets/icon/menu.svg"
                  })
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appNav), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "holder-btn",
              key: item.name,
              onClick: ($event: any) => (navigate(item.isMainButton ? checkRoute(item) : item))
            }, [
              _createVNode(_unref(IonButton), {
                fill: "clear",
                class: _normalizeClass(["navigation-menu__navigation-btn", {
          'navigation-menu__navigation-btn--main': item.isMainButton,
          'active': _unref(route)?.path?.includes(item?.url),
        }])
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    src: item.icon
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1032, ["class"])
            ], 8, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})